/**
 * Roadmap Configs API - Per-project roadmap config sync.
 */

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3100';

export async function getRoadmapConfigs(token) {
  const response = await fetch(`${API_BASE}/api/roadmap-configs`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Failed to load roadmap configs' }));
    throw new Error(err.error || 'Failed to load roadmap configs');
  }
  return response.json();
}

export async function saveRoadmapConfig(token, project, config) {
  const response = await fetch(
    `${API_BASE}/api/roadmap-configs/${encodeURIComponent(project)}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        title: config.title || '',
        subtitle: config.subtitle || '',
        phases: config.phases || [],
      }),
    }
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Failed to save roadmap config' }));
    throw new Error(err.error || 'Failed to save roadmap config');
  }
  return response.json();
}

export async function deleteRoadmapConfig(token, project) {
  const response = await fetch(
    `${API_BASE}/api/roadmap-configs/${encodeURIComponent(project)}`,
    {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  if (!response.ok && response.status !== 404) {
    const err = await response.json().catch(() => ({ error: 'Failed to delete roadmap config' }));
    throw new Error(err.error || 'Failed to delete roadmap config');
  }
  return response.json();
}
